import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex"
}
const _hoisted_2 = {
  key: 0,
  class: "ml-2 inline-flex rounded-lg font-medium leading-none py-2 px-3 bg-green-200 text-green-800"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "Successfully copied to clipboard", -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "sr-only",
  for: "copy"
}, "Hidden field for copying", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.canCopy)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("button", {
          type: "button",
          class: "ml-2 inline-block rounded-lg font-medium leading-none py-2 px-3 text-blue-700 focus:outline-none focus:shadow-outline hover:bg-gray-200",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.copyToClipboard()))
        }, "Copy code to clipboard"),
        (_ctx.copied)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _hoisted_5))
          : _createCommentVNode("", true),
        _hoisted_6,
        _withDirectives(_createElementVNode("textarea", {
          id: "copy",
          class: "sr-only",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.value) = $event))
        }, null, 512), [
          [_vModelText, _ctx.value]
        ])
      ]))
    : _createCommentVNode("", true)
}